import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRoles?: Array<'superadmin' | 'author' | 'editor' | 'writer' | 'contributor'>;
}
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requiredRoles = ['superadmin', 'author', 'editor', 'writer', 'contributor']
}) => {
  const {
    user,
    loading,
    hasRole
  } = useAuth();
  if (loading) {
    return <div className="flex justify-center items-center h-screen" data-id="element-43">
        Loading...
      </div>;
  }
  if (!user) {
    return <Navigate to="/login" data-id="element-44" />;
  }
  // Check if user has required role
  if (!hasRole(requiredRoles)) {
    return <div className="container-custom py-16 text-center" data-id="element-45">
        <h1 className="text-2xl font-bold text-navy mb-4" data-id="element-46">Access Denied</h1>
        <p data-id="element-47">
          You don't have permission to access this page. Please contact an
          administrator.
        </p>
      </div>;
  }
  return <>{children}</>;
};
export default ProtectedRoute;